import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { SubmissionError } from 'redux-form';
import axios from 'axios';
import omit from 'lodash/omit';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import isEmpty from 'lodash/isEmpty';
import { LoadingSpinner } from 'legacy-packages/ft-cb';
import get from 'lodash/get';
import dayjs from 'dayjs';
import { updateAssessmentDataCache } from 'legacy/src/actions/assessmentData';
import {
  withQuizQuestionInfo,
  hasNonSecureQn,
  withAssessmentSecurityInfo,
  convertKeysToSnakeCase,
} from 'legacy/src/components/util';
/* Remove this since temporary. More details in FY-20729 & FY-20244 */
/*import { SecureInfoIcon } from 'legacy-src/utility';*/
import hasPracticeExamBehavior from 'legacy-src/utility/hasPracticeExamBehavior';
import { isFRQ } from 'legacy-src/utility/progressHelpers';
import {
  fetchAssignmentData,
  fetchAssignmentStudentStatusData,
  removeAssignmentStudentStatusData,
} from 'legacy/src/actions/teacherAssignments';
import MustAssignInfoModal from './MustAssignInfoModal';
import ClassSwitchingInfoModal from './ClassSwitchingInfoModal';
import AssignManageForm from 'chameleon-src/components/assign/AssignManageForm';
import { getSectionStudents } from 'chameleon-src/components/assign/AssignManageForm/utils';
import { getFinishedPercent } from 'legacy/src/components/learnosity/utils/helpers';
import uniqBy from 'lodash/uniqBy';
import log from 'chameleon/ui-stack/utilities/log';
import { toast } from 'chameleon/ui-stack/ui/toast';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

import './styles.scss';

/**
 * The modal form for managing an assignment.
 * */
export class ManageForm extends Component {
  static displayName = 'ManageModal';

  static propTypes = {
    // The assignment to update
    assignment: PropTypes.object.isRequired,
    // Handler for closing the modal.
    closeManageModal: PropTypes.func.isRequired,
    // Handler for updating the parent when the assignment has been updated.
    onUpdateAssignment: PropTypes.func.isRequired,
    /*
     * we expect this to also be undefined sometimes, which is okay. we use this value to determine
     * whether or not to run the gql query that fetches this value. unfortunately this
     * will throw a prop validation error which is safe to ignore.
     */
    quizHasNonSecureQns: PropTypes.bool.isRequired,
    assessmentWithQuestionsData: PropTypes.objectOf(PropTypes.any).isRequired,
    isPPC: PropTypes.bool,
  };

  static defaultProps = {
    assessmentWithQuestionsData: {},
    isPPC: false,
  };

  constructor(props) {
    super(props);
    const { assignment, individualStudentAssignment } = this.props;
    this.state = {
      selectedAssignment: individualStudentAssignment ? assignment : null,
      selectedAssignmentUrl: null,
      showClassSwitchingInfoModal: false,
      showMustAssignInfoModal: false,
    };
  }

  componentDidMount() {
    const {
      assignment,
      fetchAssignmentStudentStatus,
      individualStudentAssignment,
    } = this.props;
    const assignemntStudentIds = this.getAssignmentStudentStatus(assignment);
    assignment &&
      individualStudentAssignment &&
      !!assignemntStudentIds.length &&
      fetchAssignmentStudentStatus(
        assignment.id,
        assignemntStudentIds,
        assignment.status,
      );
  }

  componentDidUpdate(prevProps, prevState) {
    /* eslint-disable */
    const {
      updateAssessmentDataCache,
      quizHasNonSecureQns,
      assignment,
      fetchAssignmentStudentStatus,
      individualStudentAssignment,
      assignmentStudentsStatusData,
      assessmentWithQuestionsData: { questions },
    } = this.props;
    // update redux store once value comes from the BE with information
    typeof quizHasNonSecureQns === 'boolean' &&
      prevProps.quizHasNonSecureQns !== quizHasNonSecureQns &&
      updateAssessmentDataCache(
        { [hasNonSecureQn]: quizHasNonSecureQns, questions },
        assignment.id,
      );
    const { selectedAssignment } = this.state;
    const assignemntStudentIds =
      this.getAssignmentStudentStatus(selectedAssignment);
    if (
      selectedAssignment &&
      Number(prevState.selectedAssignment.id) !==
        Number(selectedAssignment.id) &&
      individualStudentAssignment
    ) {
      // Here we're checking if the assignmentStudentsStatusData for an assignment has been fetch before.
      // if yes, fetchAssignmentStudentStatus will not be called
      isEmpty(assignmentStudentsStatusData[selectedAssignment.id]) &&
        fetchAssignmentStudentStatus(
          selectedAssignment.id,
          assignemntStudentIds,
          selectedAssignment.status,
          true,
        );
    }
  }

  onUpdateAssignmentCallback = (data) => {
    const { assignment_ids: assignmentIds = {} } = data;
    const toastLabel =
      Object.keys(assignmentIds).length > 1
        ? 'Assignments updated successfully'
        : 'Assignment updated successfully';
    toast(toastLabel, { timeout: 5 });
    this.props.onUpdateAssignment(data);
  };

  getAssignmentStudentStatus = (assignment) => {
    const { studentsBySection } = this.props;
    if (!assignment) {
      return [];
    }

    let assignemntStudentIds = [];
    const { sub_group_students, section_id, section_students } = assignment;
    if ((sub_group_students || []).length > 0) {
      assignemntStudentIds = sub_group_students;
      /**
       * we got the assignment from the legacy API, so sub_group_students
       * is actually an array of student objects instead of the chameleon
       * standard of this being an array of integer student IDs.
       * So we need to get the IDs.
       */
      if (section_students) {
        assignemntStudentIds = sub_group_students.map(({ id }) =>
          parseInt(id, 10),
        );
      }
    } else {
      assignemntStudentIds = get(
        studentsBySection,
        [parseInt(section_id, 10)],
        [],
      ).map(({ id }) => parseInt(id, 10));
    }
    return assignemntStudentIds;
  };

  /**
   * Submit form functionality. Send data to API for updating the assignment.
   * @param {object} values - The values we can update.
   * */
  onSubmit = (values) => {
    const {
      assignment,
      canUpdateAll,
      manageMultipleClassesFlag,
      individualStudentAssignment,
      subjectData: { classes: subjectClassList = [] },
      removeAssignmentStudentStatus,
      studentsBySection,
    } = this.props;
    const {
      updateAll,
      matchingAssignments,
      students: allFormStudents,
      assignees,
    } = values;
    const uniqueFormStudents = uniqBy(allFormStudents, 'id');

    const formStudents = (uniqueFormStudents || []).filter(
      (student) => !student.fromOtherISA,
    );
    const { id: assignmentId } = assignment;

    const { selectedAssignment } = this.state;

    const selectedAssignmentId =
      (selectedAssignment && selectedAssignment.id) || assignmentId;
    const isSameAssignment = selectedAssignmentId === assignmentId;

    let updateParams = { ...values };

    /*
     * Our student.id field has STUDENT_ID__SECTION_ID__ASSIGNMENT_ID structure.
     * This is used for separating students within the assign/manage form based on different ISAs.
     * Therefore we need to set back the student.id field to STUDENT_ID (student.studentId property)
     * before sending the data the the backend.
     * */
    const students = (formStudents || []).map((student) => ({
      ...student,
      id: student.studentId,
    }));

    updateParams = convertKeysToSnakeCase(
      omit(updateParams, ['matchingAssignments']),
    );
    const getStudentIds = (studentsList, sectionId, assignmentId = null) => {
      if (!!studentsList) {
        return studentsList
          .filter((student) => {
            const isSectionStudent = student.sectionId === sectionId;

            if (assignmentId) {
              return isSectionStudent && student.assignmentId === assignmentId;
            }

            return isSectionStudent;
          })
          .map((student) => parseInt(student.id));
      }
      return [];
    };

    const hasAssignees = (sectionId) =>
      assignees && !!assignees.find((assignee) => assignee.id === sectionId);

    if (manageMultipleClassesFlag && canUpdateAll && updateAll) {
      const updateAssignees = matchingAssignments
        .map((assignment) => {
          const { id, sub_group_students, section_students } = assignment;
          const sectionId = assignment.section_id.toString();

          let subgroupStudentIds = sub_group_students;
          /**
           * we got the assignment from the legacy API, so sub_group_students
           * is actually an array of student objects instead of the chameleon
           * standard of this being an array of integer student IDs.
           * So we need to get the IDs.
           */
          if (section_students) {
            subgroupStudentIds = sub_group_students.map(({ id }) =>
              parseInt(id, 10),
            );
          }

          const assignmentStudents = get(
            studentsBySection,
            [parseInt(assignment.section_id, 10)],
            [],
          )
            .filter(({ id: studentId }) =>
              subgroupStudentIds.includes(parseInt(studentId)),
            )
            .map((s) => ({
              ...s,
              sectionId: sectionId.toString(),
            }));
          const sectionStudentsLength = getSectionStudents(
            subjectClassList,
            sectionId,
          ).length;
          let newStudentIds = [];
          let oldStudentIds = [];

          if (individualStudentAssignment) {
            const formSectionStudentIds = getStudentIds(
              students,
              sectionId,
              assignment.id,
            );

            newStudentIds = hasAssignees(sectionId)
              ? assignmentStudents.map((student) => parseInt(student.id))
              : formSectionStudentIds.length === sectionStudentsLength
                ? []
                : formSectionStudentIds;
            oldStudentIds = getStudentIds(assignmentStudents, sectionId);
          }

          return {
            id: String(id),
            type: 'group',
            assignmentId: String(id),
            student_ids: newStudentIds,
            old_student_ids: oldStudentIds,
          };
        })
        .sort((a) => (a.id !== String(selectedAssignmentId) ? -1 : 1));
      updateParams = {
        ...omit(updateParams, ['assignees', 'allAssignees', 'students']),
        assignees: updateAssignees,
      };

      if (updateParams.starts_at && updateParams.starts_at instanceof dayjs) {
        updateParams.starts_at = updateParams.starts_at
          .utcOffset(0, true)
          .format();
      }

      if (updateParams.due_at && updateParams.due_at instanceof dayjs) {
        updateParams.due_at = updateParams.due_at.utcOffset(0, true).format();
      }

      return axios
        .post(
          `${FYM_BACKEND_URL}/assessments/api/assignments/update/`,
          updateParams,
        )
        .then((response) => {
          const { errors } = response.data;

          if (errors) {
            throw new SubmissionError(errors);
          } else {
            const assignmentIds = updateParams.assignees.map((assignee) =>
              Number.parseInt(assignee.assignmentId, 10),
            );
            removeAssignmentStudentStatus(assignmentIds);
            this.onUpdateAssignmentCallback(response.data);
            this.redirectToSelectedAssignmentUrl();
          }
        });
    }

    const assignmentFinishedPercentage = getFinishedPercent(
      assignment.progress,
    );

    /*
     * Use finished percentage to not apply the ISA parameters when updating a completed assignment.
     * This is needed because completed assignments should be updated, but they are not found in `matchingAssignments`.
     * Therefore we shall use the old way to update the assignment, without adding `new_student_ids` and `old_student_ids`.
     * */
    const isCompletedAssignment =
      assignment.status === 'closed' || assignmentFinishedPercentage === 100;
    if (individualStudentAssignment && !isCompletedAssignment) {
      const currentAssignment =
        matchingAssignments &&
        matchingAssignments.find(
          (singleAssignment) =>
            Number.parseInt(singleAssignment.id, 10) ===
            Number.parseInt(selectedAssignmentId, 10),
        );
      const {
        section_id: intSectionId,
        sub_group_students,
        section_students,
      } = currentAssignment || {};
      let subgroupStudentIds = sub_group_students;
      /**
       * we got the assignment from the legacy API, so sub_group_students
       * is actually an array of student objects instead of the chameleon
       * standard of this being an array of integer student IDs.
       * So we need to get the IDs.
       */
      if (section_students) {
        subgroupStudentIds = sub_group_students.map(({ id }) =>
          parseInt(id, 10),
        );
      }
      const currentAssignmentStudents = get(
        studentsBySection,
        [parseInt(intSectionId, 10)],
        [],
      )
        .filter(({ id }) => subgroupStudentIds.includes(parseInt(id)))
        .reduce((acc, current) => {
          current['sectionId'] = intSectionId;
          acc.push(current);
          return acc;
        }, []);
      const stringSectionId = intSectionId.toString();
      const sectionStudentsLength = getSectionStudents(
        subjectClassList,
        stringSectionId,
      );
      const currentAssignmentFormStudents = students.filter(
        (student) =>
          Number.parseInt(student.assignmentId, 10) ===
          Number.parseInt(currentAssignment.id, 10),
      );
      const newStudentIds = currentAssignmentFormStudents.map((student) =>
        parseInt(student.id),
      );
      updateParams = {
        ...omit(updateParams, ['assignees', 'allAssignees', 'students']),
        student_ids:
          newStudentIds.length === sectionStudentsLength.length
            ? []
            : newStudentIds,
        old_student_ids: getStudentIds(currentAssignmentStudents, intSectionId),
      };
    }

    if (updateParams.starts_at) {
      updateParams.starts_at = updateParams.starts_at
        .utcOffset(0, true)
        .format();
    }

    if (updateParams.due_at) {
      updateParams.due_at = updateParams.due_at.utcOffset(0, true).format();
    }

    if (!updateParams.due_at && updateParams.allow_late_submission) {
      updateParams.allow_late_submission = false;
    }

    return axios
      .put(
        `${FYM_BACKEND_URL}/assessments/api/assignments/${selectedAssignmentId}/`,
        updateParams,
      )
      .then((response) => {
        const { errors } = response.data;

        if (errors) {
          throw new SubmissionError(errors);
        } else {
          removeAssignmentStudentStatus([selectedAssignmentId]);
          this.onUpdateAssignmentCallback(response.data);
          if (!isSameAssignment) {
            return this.redirectToSelectedAssignmentUrl();
          }
          this.refreshProgressPageData();
          // close modal when settings were updated
          // https://academicmerit.atlassian.net/browse/FY-29131
          this.props.closeManageModal();
        }
      });
  };

  getAssignment = (assignmentId) =>
    axios.get(
      `${FYM_BACKEND_URL}/assessments/api/assignments/${assignmentId}/`,
    );

  refreshProgressPageData = () => {
    const {
      router,
      params: { assignmentId },
      fetchAssignmentData,
      chosenEducationPeriod,
    } = this.props;
    const {
      location: { pathname },
    } = router;
    if (pathname.includes('progress')) {
      fetchAssignmentData(assignmentId, {
        education_period: chosenEducationPeriod,
      });
    }
  };

  fetchSingleAssignmentData = (id = null) => {
    if (id) {
      this.getAssignment(id)
        .then((assignmentResponse) => {
          this.setState({ selectedAssignment: assignmentResponse.data });
        })
        .catch((error) => {
          log('error', error);
        });
    }
  };

  redirectToSelectedAssignmentUrl = () => {
    const { isAssign, routes } = this.props;
    const { selectedAssignmentUrl } = this.state;
    const isProgressRoute = routes.length > 3 && routes[3].path === 'progress';

    if (selectedAssignmentUrl && !isAssign && isProgressRoute) {
      this.props.router.push(selectedAssignmentUrl);
    } else {
      this.refreshProgressPageData();
    }
  };

  handleShowClassSwitchingInfoModal = (status = false) =>
    this.setState({ showClassSwitchingInfoModal: status });

  onHandleShowClassSwitchingInfoModal = (event) => {
    this.handleShowClassSwitchingInfoModal();
    event.preventDefault();
  };

  handleShowMustAssignInfoModal = (status = false) =>
    this.setState({ showMustAssignInfoModal: status });

  onHandleShowMustAssignInfoModal = (event) => {
    this.handleShowMustAssignInfoModal();
    event.preventDefault();
  };

  render() {
    const {
      closeManageModal,
      assignment,
      assessmentDataCache,
      quizHasNonSecureQns,
      isPracticeExam,
      quizHasAnySecureQnsPE,
      showAttestation,
      assessmentWithQuestionsData: { questions },
      subjectInfo,
      shouldFetchOtherAssignments,
      canUpdateAll,
      manageMultipleClassesFlag,
      itemId,
      individualStudentAssignment,
      isFetchingAssignmentStudentsStatusData,
      isAssessmentSecurityInfoLoading,
      isCasAssignmentFF,
      allowLateSubmissionFF,
    } = this.props;

    // If we have a 'selectedAssignment' that means that the
    // assignment we're modifying is not the one that appears
    // when opening the modal, but another assignment for the same
    // assessment
    const {
      selectedAssignment,
      showClassSwitchingInfoModal,
      showMustAssignInfoModal,
    } = this.state;

    // The first time the modal opens, we default to assignment,
    // later when the user selects another class,
    // selectedAssignment won't be null anymore
    const currentAssignment = selectedAssignment || assignment;

    const { title } = currentAssignment;

    // use value cached in redux if available, otherwise the gql request will return the value from the BE
    const cache = assessmentDataCache
      ? assessmentDataCache[currentAssignment.id] || assessmentDataCache[itemId]
      : {};
    const hasCache = cache && cache[hasNonSecureQn];
    const hasAudioRecordOrFileUpload = !!(hasCache || quizHasNonSecureQns);
    const withPracticeExamBehavior = hasPracticeExamBehavior(
      isPracticeExam,
      questions,
    );
    const modalTitleText = `Assignment Settings for ${title}`;
    const hasFrqQuestions = questions && !!questions.find(isFRQ);
    const showStudentScoring = hasFrqQuestions;

    const handleClose = () => {
      closeManageModal();
    };

    const setSelectedAssignmentUrl = (selectedAssignmentUrl) => {
      this.setState({ selectedAssignmentUrl });
    };

    return (
      <ConfirmDialog
        data-test-manage-assignment-modal
        size="big"
        contentWithSpacing={false}
        title={<span className="ellipsis">{modalTitleText}</span>}
        onClose={handleClose}
      >
        {isFetchingAssignmentStudentsStatusData ||
        isAssessmentSecurityInfoLoading ? (
          <LoadingSpinner />
        ) : (
          <Fragment>
            <AssignManageForm
              {...this.props}
              isAssessmentForm
              hideSecureToggle={hasAudioRecordOrFileUpload}
              showAttestationFlag={showAttestation}
              hasSecureQns={quizHasAnySecureQnsPE}
              hasAudioRecordOrFileUpload={hasAudioRecordOrFileUpload}
              onClose={closeManageModal}
              onSubmit={this.onSubmit}
              canUpdateAll={manageMultipleClassesFlag ? canUpdateAll : null}
              assignment={currentAssignment}
              selectedAssignment={selectedAssignment}
              setSelectedAssignmentUrl={setSelectedAssignmentUrl}
              subjectInfo={subjectInfo}
              shouldFetchOtherAssignments={shouldFetchOtherAssignments}
              fetchSingleAssignmentData={this.fetchSingleAssignmentData}
              hasPracticeExamBehavior={withPracticeExamBehavior}
              showStudentScoring={showStudentScoring}
              shouldRedirectAfterSubmitting
              handleShowClassSwitchingInfoModal={
                this.handleShowClassSwitchingInfoModal
              }
              handleShowMustAssignInfoModal={this.handleShowMustAssignInfoModal}
              spacingAroundContent="p-6"
              isCasAssignmentFF={isCasAssignmentFF}
              allowLateSubmissionFF={allowLateSubmissionFF}
            />
            {showClassSwitchingInfoModal && individualStudentAssignment && (
              <ClassSwitchingInfoModal
                onHandleShowClassSwitchingInfoModal={
                  this.onHandleShowClassSwitchingInfoModal
                }
              />
            )}
            {showMustAssignInfoModal && individualStudentAssignment && (
              <MustAssignInfoModal
                onHandleShowMustAssignInfoModal={
                  this.onHandleShowMustAssignInfoModal
                }
              />
            )}
          </Fragment>
        )}
      </ConfirmDialog>
    );
  }
}

export default compose(
  connect(
    (state) => ({
      secure_browser: state.featureFlag.secure_browser,
      assessmentDataCache: state.assessmentDataCache,
      showAttestation: state.featureFlag.show_attestation_confirmation_dialog,
      manageMultipleClassesFlag:
        state.featureFlag.assignment_manage_classes_dropdown,
      subjectData: state.subject.data,
      studentsBySection: state.studentsBySection || {},
      individualStudentAssignment:
        state.featureFlag.individual_student_assignment,
      isCasAssignmentFF:
        state.featureFlag.individual_student_assignment_settings,
      teacherAssignment: state.teacherAssignment.assignment,
      chosenEducationPeriod: state.userData.chosenEducationPeriodCode,
      assignmentStudentsStatusData:
        state.assignmentStudentsStatus.assignmentStudentsStatusData,
      isFetchingAssignmentStudentsStatusData:
        state.assignmentStudentsStatus.isFetching,
      allowLateSubmissionFF: state.featureFlag.allow_late_submission,
      allowHardTimer: state.featureFlag.updated_timer_controls,
    }),
    {
      updateAssessmentDataCache,
      fetchAssignmentData,
      fetchAssignmentStudentStatus: fetchAssignmentStudentStatusData,
      removeAssignmentStudentStatus: removeAssignmentStudentStatusData,
    },
  ),
  withQuizQuestionInfo,
  withAssessmentSecurityInfo,
)(withRouter(ManageForm));
